<div class="p-field p-col-12 p-md-0" [ngClass]="customClass">
  <label [for]="label">{{ label }}</label>
  <p-select
    [options]="options"
    [(ngModel)]="selectedValue"
    (onChange)="onValueChange($event)"
    [placeholder]="placeholder"
    [id]="label"
    [ariaLabel]="label"
    [disabled] = "disabled"
    apendTo = "body"
  ></p-select>
</div>
